import(/* webpackMode: "eager" */ "/vercel/path0/src/app/features/page.tsx");
